/* shop-the-look.js — v3: prickar, popup-kort, koppling till produktlistan och Köp hela rummet */
(function () {
  'use strict';
  var CARD_OFFSET = 12;

  function init(root) {
    root.querySelectorAll('[data-stl-look]').forEach(function (look) {
      if (look.dataset.stlReady) return;
      look.dataset.stlReady = '1';
      var wrap = look.querySelector('.stl-image-wrap');

      look.querySelectorAll('.stl-hotspot').forEach(function (btn) {
        var id = btn.dataset.hotspotId;
        var row = look.querySelector('[data-strip-hotspot="' + id + '"]');

        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var card = document.getElementById('card-' + id);
          if (!card) return;
          var wasOpen = !card.hidden;
          closeAll(look);
          if (!wasOpen) openCard(btn, card, wrap, row);
        });

        btn.addEventListener('mouseenter', function () { setActive(btn, row, true); });
        btn.addEventListener('mouseleave', function () { if (btn.getAttribute('aria-expanded') !== 'true') setActive(btn, row, false); });

        if (row) {
          row.addEventListener('mouseenter', function () { setActive(btn, row, true); });
          row.addEventListener('mouseleave', function () { if (btn.getAttribute('aria-expanded') !== 'true') setActive(btn, row, false); });
          row.addEventListener('focusin', function () { setActive(btn, row, true); });
          row.addEventListener('focusout', function () { if (btn.getAttribute('aria-expanded') !== 'true') setActive(btn, row, false); });
        }
      });
    });
  }

  function setActive(btn, row, on) {
    btn.classList.toggle('is-active', on);
    if (row) row.classList.toggle('is-active', on);
  }

  function openCard(btn, card, wrap, row) {
    card.hidden = false;
    card.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    setActive(btn, row, true);
    position(btn, card, wrap);
  }

  function closeCard(card) {
    card.hidden = true;
    card.classList.remove('is-open');
    var id = card.id.replace(/^card-/, '');
    var look = card.closest('[data-stl-look]');
    if (!look) return;
    var btn = look.querySelector('[data-hotspot-id="' + id + '"]');
    var row = look.querySelector('[data-strip-hotspot="' + id + '"]');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); setActive(btn, row, false); }
  }

  function closeAll(scope) {
    (scope || document).querySelectorAll('.stl-card.is-open').forEach(closeCard);
  }

  function position(btn, card, wrap) {
    var w = wrap.getBoundingClientRect();
    var b = btn.getBoundingClientRect();
    var cx = b.left - w.left + b.width / 2;
    var cy = b.top - w.top + b.height / 2;
    card.style.left = '0'; card.style.top = '0';
    var cw = card.offsetWidth, ch = card.offsetHeight;
    var left = cx + b.width / 2 + CARD_OFFSET;
    if (left + cw > w.width - 8) left = cx - b.width / 2 - CARD_OFFSET - cw;
    left = Math.max(8, Math.min(left, w.width - cw - 8));
    var top = cy - ch / 2;
    top = Math.max(8, Math.min(top, w.height - ch - 8));
    card.style.left = left + 'px';
    card.style.top = top + 'px';
  }

  document.addEventListener('click', function (e) {
    var close = e.target.closest('.stl-card__close');
    if (close) { var c = close.closest('.stl-card'); if (c) closeCard(c); return; }
    if (!e.target.closest('.stl-hotspot') && !e.target.closest('.stl-card')) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ── Köp hela rummet ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-stl-buyall]');
    if (!btn || btn.classList.contains('is-loading')) return;
    var ids = (btn.dataset.variants || '').split(',').filter(Boolean);
    if (!ids.length) return;
    var msg = btn.parentNode.querySelector('.stl-buyall__msg');
    if (msg) msg.textContent = '';
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (res.ok) { window.location.href = root + 'cart'; return; }
        throw new Error(res.data && (res.data.description || res.data.message));
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        if (msg) msg.textContent = (err && err.message) ? err.message : 'Något gick fel. Försök igen eller lägg till produkterna en och en.';
      });
  });

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
